import { render, staticRenderFns } from "./PhoneSendMessages.vue?vue&type=template&id=814ed894&scoped=true"
import script from "./PhoneSendMessages.vue?vue&type=script&lang=js"
export * from "./PhoneSendMessages.vue?vue&type=script&lang=js"
import style0 from "./PhoneSendMessages.vue?vue&type=style&index=0&id=814ed894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814ed894",
  null
  
)

export default component.exports